import {app} from '../../app';
import {ISessionService} from "../../services/SessionService";
import {SelectQuestionPreviewComponent} from "./SelectQuestionPreviewComponent";

export class SelectNumericQuestionPreviewComponent extends SelectQuestionPreviewComponent {

    $onInit() {
        let meta = this.question.meta;
        let choicesFrom = meta.choicesFrom;
        let choicesTo = meta.choicesTo;

        if (isFinite(choicesFrom) && isFinite(choicesTo)) {
            for (let i = choicesFrom; i <= choicesTo; i++) {
                this.choices.push(i.toString());
            }
        }

        super.$onInit();
    }


}

app.component('selectNumericQuestionPreview', {
    templateUrl: 'templates/components/questionPreviews/selectNumericQuestionPreview.html',
    controller: SelectNumericQuestionPreviewComponent,
    controllerAs: 'selectNumericQuestionPreview',
    bindings: {
        question: '<'
    }
});